import fetch from '@/utils/fetch'

export function getAcsDetailData (query) {
  return fetch({
    url: '/order/acs/deatil',
    method: 'get',
    params: query
  })
}

export function onAcsOption(data) {
  return fetch({
    url: '/order/acs/option',
    method: 'post',
    data
  })
}
